// Environment Configuration
export const ENV_CONFIG = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'Lazismu Donation',
  APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || 'Platform donasi untuk program-program Lazismu',
  NODE_ENV: import.meta.env.MODE || 'development',
  IS_DEV: import.meta.env.DEV || false,
  IS_PROD: import.meta.env.PROD || false,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  MIDTRANS_CLIENT_KEY: import.meta.env.VITE_MIDTRANS_CLIENT_KEY || '',
  MIDTRANS_IS_PROD: import.meta.env.VITE_MIDTRANS_IS_PROD === 'true',
  FIREBASE: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || '',
  },
} as const;

// Helper function to get environment variable
export function getEnvVar<K extends keyof typeof ENV_CONFIG>(key: K): (typeof ENV_CONFIG)[K] {
  return ENV_CONFIG[key];
}

// Helper function to check if we're in development
export function isDevelopment(): boolean {
  return ENV_CONFIG.IS_DEV;
}

// Helper function to check if we're in production
export function isProduction(): boolean {
  return ENV_CONFIG.IS_PROD;
}
